import React from 'react';
import useStyles from './useStyles';

export type Props = {
  id?: Element['id'];
  enabled?: boolean;
  size?: string | null; // used to decide if width/height is applied
  height?: number;
  width?: number;
  verticalAlignment?: string;
  image: {
    url: string;
  };
  altText?: string;
  children?: never;
} & React.HTMLAttributes<HTMLDivElement>;

export function Logo({
  id,
  enabled = true,
  size = null,
  height,
  width,
  image: { url },
  verticalAlignment = 'LEFT_TOP',
  altText = '',
  ...props
}: Props): React.ReactElement {
  const { logoContainer, logoWrapper, logoImage } = useStyles({ verticalAlignment, size, width, height });
  return (
    <If condition={enabled}>
      <div id={id} className={logoContainer} {...props}>
        <div className={logoWrapper}>
          <img src={url} alt={altText} className={logoImage} />
        </div>
      </div>
    </If>
  );
}

export default Logo;
